import React from 'react';
import PropTypes from 'prop-types';

import { Text, Spacer, Button } from '@zillow/constellation';
import { HR } from '@zillow/zrs-comet';

const propTypes = {
    archived: PropTypes.bool.isRequired,
    hasArchiveRestriction: PropTypes.bool.isRequired,
    isArchiveButtonDisabled: PropTypes.bool.isRequired,
    handleArchiveOrUnArchive: PropTypes.func.isRequired,
};

const ArchiveButton = ({
    archived, // from details endpoint
    isArchived, // from overview endpoint
    hasArchiveRestriction,
    isArchiveButtonDisabled,
    handleArchiveOrUnArchive,
}) => (
    <div>
        <HR />
        <Text>
            {(archived || isArchived) ?
                'If you wish to begin using this property' :
                'No longer own or manage this property?'
            }
        </Text>
        <Spacer paddingY="xs">
            <Button
                fluid={true}
                buttonType="secondary"
                onClick={handleArchiveOrUnArchive}
                disabled={isArchiveButtonDisabled}
            >
                {(archived || isArchived) ? 'Unarchive property' : 'Archive property'}
            </Button>
            {hasArchiveRestriction && (
                <Text fontType="finePrint">
                        Properties that are listed for rent or
                        collecting rent payments cannot be archived.
                </Text>
            )}
        </Spacer>
    </div>
);

ArchiveButton.propTypes = propTypes;

export default ArchiveButton;
